import project from './project';
import LiuCheng from './liucheng';

export default {
    path: 'revision',
    component: () => import(/*webpackChunkName: 'revision-bidding-project'*/ '@layout/empty'),
    children: [
        project,
        LiuCheng,
    ]
}